import { useMatch } from 'react-router-dom';

/**
 * Custom hook for matching a Route when you are outside one. Checks each route and returns the first route matched.
 * @param {object} routes - your routes object
 * @returns {match}
 */
export default function useCurrentRoute(routes) {
  const keys = Object.keys(routes);
  let routeInfo = null;
  for (const key of keys) {
    const match = useMatch(routes[key]);
    if (match && routeInfo === null) {
      routeInfo = match;
    }
  }
  return routeInfo;
}
